import React from "react";
import ginza from "./ginza..json";
import "./ginza.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah.jsx";
import benchwalk from "../../../asset/ginza/beachwalk/benchwalk.js";
import penthouse from "../../../asset/ginza/penthouse/penthouse.js";
const imageMap = {
  benchwalk,
  penthouse,
  // Add other image arrays here if you have more sets
};

const Ginza = () => {
  return (
    <div className="ginza">
      <div className="container-ginza">
        <div className="header">
          <div className="judul-ginza">
            <div className="pink"></div>
            <span>Ginza District</span>
          </div>
        </div>
        <div className="cardhome-container">
          {ginza.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Ginza;
